import { useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts/CustomerProvider";
export const getCoverDetails = async (event_id, code, userId) => {
    if (!userId || !event_id || !code)
        return null;
    const { data } = await API.get(`/api/v1/rbzo/wallet/coverDetails?user_id=${userId}&event_id=${event_id}&code=${code}`);
    return data;
};
export const useCoverDetails = (event_id, code, enabled) => {
    var _a;
    const { customerData } = useCustomer();
    const userId = (_a = customerData === null || customerData === void 0 ? void 0 : customerData.id) !== null && _a !== void 0 ? _a : null;
    return useQuery(["coverDetails", event_id, code, userId], () => getCoverDetails(event_id, code, userId), {
        enabled: !!enabled && !!userId && !!event_id && !!code,
    });
};
